import FourOhFour from '../404';

export default function index(props) {
    return <FourOhFour {...props} />;
}